import { Leaf } from "lucide-react";
import { T } from "@/i18n";

const PHASES = ["Analizziamo la tua richiesta", "Scegliamo i quartieri giusti", "Bilanciamo le giornate", "Calcoliamo il TS Impact Score"];

export const LoadingState = ({ chars }) => {
  const pct = Math.min(96, Math.round((chars / 8500) * 100));
  const phase = PHASES[Math.min(PHASES.length - 1, Math.floor(pct / 25))];
  return (
    <div data-testid="trip-loading-state" className="mt-10 rounded-3xl border border-emerald-100 bg-emerald-50/50 p-8 md:p-10">
      <div className="flex items-center gap-4">
        <Leaf className="leafspin h-7 w-7 text-emerald-600" />
        <div>
          <p className="font-display text-lg font-semibold text-gray-900"><T>{phase}</T>...</p>
          <p className="text-sm text-gray-500"><T>Di solito serve circa 1–2 minuti. Puoi lasciare aperta la pagina.</T></p>
        </div>
        <span data-testid="trip-loading-percent" className="ml-auto font-display text-2xl font-bold text-emerald-700">{pct}%</span>
      </div>
      <div className="mt-6 h-2 overflow-hidden rounded-full bg-emerald-100">
        <div className="h-full rounded-full bg-gradient-to-r from-emerald-600 to-emerald-400 transition-[width] duration-500" style={{ width: `${pct}%` }} />
      </div>
      <div className="mt-8 grid gap-3 sm:grid-cols-3">
        {[0, 1, 2].map((i) => <div key={i} className="h-24 animate-pulse rounded-2xl bg-white" />)}
      </div>
    </div>
  );
};
